export const messages = {
    "QuestionTitle" : "Please type a question text for your question",
    "QuestionMandatory" : "Please type the message for the mandatory option",
    "QuestionCategory" : "Please select a category for your question",
    "QuestionTooltipDescription" : "Please type the description text for the question tooltip",
    "GroupNoMembers" : "Cannot create a group with no members",
    "GameDeletedSuccess" : "Game deleted successfully",
    "GameStatusUpdatedSuccess" : "Game status updated successfully",
    "GenericError" : "An error occurred, please try again",
}